export default "__VITE_PUBLIC_ASSET__6f8894b0__"